/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettlementDto } from '../../models/settlement-dto';

export interface SettlementControllerCompleteSettlement$Params {

/**
 * 정산 ID
 */
  id: string;
}

export function settlementControllerCompleteSettlement(http: HttpClient, rootUrl: string, params: SettlementControllerCompleteSettlement$Params, context?: HttpContext): Observable<StrictHttpResponse<SettlementDto>> {
  const rb = new RequestBuilder(rootUrl, settlementControllerCompleteSettlement.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettlementDto>;
    })
  );
}

settlementControllerCompleteSettlement.PATH = '/api/settlement/{id}/complete';
